import { Component, Vue, Ref, Prop, Inject} from 'vue-property-decorator'
// import widget from '../widget/widgetInRecord';
// import associationTable from '../components/associationTable.vue';
import { permissionE } from '../widget/types';
import { formatShortTime, authorityShow, isUndef } from '@/utils/common';
// import cell from '../cell.vue';
// import moreOprate from '../components/moreOprate.vue';
import * as sheetAPI from '@/apis/sheet';
import { cloneDeep } from 'lodash';
import { initField, resultFnObj } from '../widget/valueConfig';
import { AppModule } from '@/store/modules/app';
import { getFormula } from '@/utils/formula';
import { selectE } from '../widget/types';
import { handleValueFormula } from '../widget/valueConfig';
import { difference } from 'lodash';
import { getSheetConfig } from '@/apis/sheetConfig'
// 纯展示字段
const notAddField = ['cuttingLine', 'remark'];
// 默认值为空数组的字段
const defaultArrField = ['checkbox', 'accessory', 'associationTable'];
const reg = /#queId_(\S+?)\$/g;
@Component({
  name: 'common',
  components: {
    widget: () => import('../widget/widgetInRecord'),
    cell: () => import('../cell.vue'),
    moreOprate: () => import('../components/moreOprate.vue'),
    associationTable: () => import('../components/associationTable.vue') ,
  }
})
export default class extends Vue {
  @Ref() public widgetArr!: any;
  public operateArr = [] as any[];
  public recordInfo = {
    updateTime: '',
    type: '创建于',
    updateUser: '',
    canEdit: true,
    canDelete: true,
  };
  public drawer = {
    visiable: false,
    type: 'add',
    title: '新建',
  };
  // 表单内容是否发生改变
  public isChange = false;
  public id: string = '';
  public form = {};
  public cacheData = {}; // 用于取消编辑时的回显
  public associationForm = {};
  public showFieldList: any[] = [];
  public customTriggerProperties: any[] = [];
  public associationTableList: any[] = [];
  public permissionHiddenList: any[] = [];
  private unWatchList: any[] = [];
  private isReadOnly = false;
  // 自定义按钮弹窗
  private customBtnDialog: any = {
    customBtnVisible: false,
    title: '',
    fieldAuthoritiesMap: {},
    showFields: [],
    form: {},
  };
  public watchForm: any = () => void 0;
  private get fieldsMap() {
    let obj = {};
    let sheetFieldList = (this as any).sheetFieldList;
    sheetFieldList.forEach((item) => {
      obj[item.businessId] = item;
    });
    return obj;
  }
  private get expandConfig() {
    if (this.$store.state.sheet) {
      return this.$store.state.sheet.expandConfig;
    } else {
      return {};
    }
  }
  private get titleField() {
    return this.fieldsMap[(this as any).titleBusinessId] || {};
  }
  public initForm(data?: any, backInfo?: any) {
    this.cacheData = cloneDeep(data);
    this.drawer.visiable = true;
    this.form = {};
    this.associationForm = {};
    this.showFieldList = [];
    this.associationTableList = [];
    this.permissionHiddenList = [];
    this.unWatchList.forEach((fieldWacth) => {
      fieldWacth();
    });
    this.unWatchList = [];
    if (data) {
      this.isReadOnly = true;
      this.drawer.type = 'edit';
      this.id = data.id;
      this.customTriggerProperties = data.customTriggerProperties || [];
      let updateUser = this.$store.state.app.workerMap[data.updateUser || data.createUser] || {};
      this.recordInfo = {
        updateTime: formatShortTime(data.updateTime || data.createTime),
        type: data.updateTime ? '更新于' : '创建于',
        updateUser,
        canEdit: isUndef(data.canEdit) ? true : data.canEdit,
        canDelete: isUndef(data.canDelete) ? false : data.canDelete,
      };
    } else {
      this.isReadOnly = false;
      this.drawer.type = 'add';
      this.drawer.title = '新建';
      this.recordInfo.canEdit = true;
    }
    this.$nextTick(() => {
      let { showFieldList, associationTableList, permissionHiddenList } = this.getFieldList(
        this.drawer.type,
        (this as any).sheetFieldList
      );
      this.showFieldList = showFieldList;
      this.associationTableList = associationTableList;
      this.permissionHiddenList = permissionHiddenList;
      this.associationTableList.forEach((item) => {
        let value = data[item.businessId] || [];
        this.$set(this.associationForm, item.businessId, value);
      });
      this.showFieldList.forEach((item) => {
        if (!notAddField.includes(item.fieldType)) {
          let value: string | any[] | undefined;
          this.$set(this.form, item.businessId, initField(item));
        }
      });
      this.permissionHiddenList.forEach((item) => {
        this.$set(this.form, item.businessId, initField(item));
      });
      if (this.drawer.type === 'edit') {
        this.form = Object.assign({}, this.form, data);
      }
      let arr = [...this.permissionHiddenList, ...this.showFieldList];
      arr.forEach((item) => {
        if (item.fieldType === 'department' || item.fieldType === 'member') {
          this.getDynamicValue(item);
        } else {
          let resultFn = resultFnObj[item.fieldType] || resultFnObj.common;
          this.autoDefault(item, resultFn);
        }
      });
      if (backInfo) {
        this.form = Object.assign({}, this.form, backInfo);
      }
    });
    setTimeout(() => {
      // (this.$refs.form as any).clearValidate()
      this.isChange = true;
      if (this.drawer.type === 'edit') {
        this.addFormWatch();
      }
    });
  }
  // 添加字段form的监听
  public addFormWatch() {
    this.isChange = false;
    this.watchForm();
    this.watchForm = this.$watch(
      'form',
      () => {
        this.isChange = true;
        this.watchForm();
      },
      { deep: true }
    );
  }
  public close() {
    this.drawer.visiable = false;
  }
  public recordChange({ businessId }, data) {
    this.showFieldList.forEach((field) => {
      if (field.fieldType === 'associationField' && field.associationTableId === businessId) {
        this.form[field.businessId] = data[field.displayField];
      }
    });
  }
  public cancel(a) {
    if (this.drawer.type === 'add') {
      this.$emit('search', 'add');
    } else {
      this.initForm(this.cacheData);
    }
  }
  private changeEditState() {
    this.isReadOnly = false;
  }
  private moreOprate() {
    let oprate = this.$refs.moreOprate as any;
    oprate.open();
    const arr = [
      { name: '查看评论', key: 'discussion' },
      { name: '查看日志', key: 'log' },
      { name: '查看流程轨迹', key: 'track' },
      { name: '删除', color: '#ee0a24', key: 'delete' },
    ];
    this.operateArr = arr.filter((item) => {
      if ((this as any).processId) {
        return item.key === 'track';
      } else {
        return (
          item.key === 'log' ||
          item.key === 'discussion' ||
          (item.key === 'delete' && (this.recordInfo.canDelete || (this as any).isAdmin))
        );
      }
    });
  }
  private permissionHidden(item, type) {
    let priorityAuthority = (this as any).priorityAuthorityMap[item.businessId];
    if (priorityAuthority && priorityAuthority === 'hidden') {
      return true;
    } else if (priorityAuthority) {
      return false;
    }
    if (item.permissions && item.permissions.includes(permissionE.hidden)) {
      return true;
    }
    if (this.drawer.type === 'edit' && (this as any).hideRow.includes(item.businessId)) {
      return true;
    }
    if (!authorityShow((this as any).isAdmin, { canRead: true }, item.fieldAuthority, type)) {
      return true;
    }
  }
  private getFieldList(type, sheetFieldList) {
    let showFieldList: any[] = [];
    let associationTableList: any[] = [];
    let permissionHiddenList: any[] = [];
    sheetFieldList.forEach((item) => {
      if (item.isSystem) {
        return false;
      }
      if (this.permissionHidden(item, type)) {
        permissionHiddenList.push(item);
      } else if (type === 'edit' && item.displayMode === 2) {
        associationTableList.push(item);
      } else {
        showFieldList.push(item);
      }
    });
    return { showFieldList, associationTableList, permissionHiddenList };
  }
  // 保存自定义按钮
  private saveCustomBtnForm() {
    let form = this.$refs.customBtnform as any;
    let p1 = form.validate();
    let data = {};
    p1.then(async () => {
      // 现实的字段提交
      (this.$refs.customBtnWidgetArr as any).forEach((one) => {
        // 备注，分割线不添加
        if (notAddField.includes(one.item.fieldType)) {
          return;
        }
        if (one.item.fieldType === 'autoNumber') {
          return;
        }
        let businessId = one.item.businessId;
        data[businessId] = this.customBtnDialog.form[businessId];
      });
      let res = await this.updateRecord(data);
      if (res.success) {
        const oprate = this.$refs.moreOprate as any;
        oprate.fetchCustomTrigger(this.customBtnDialog.row, true);
        this.customBtnDialog.customBtnVisible = false;
      }
    }).catch((e) => {
      console.log(e);
    });
  }
  // 触发自定义按钮，指定字段弹窗
  private triggerBtnForm(row) {
    let fieldAuthorities = row.customTriggerHandledProperty.fieldAuthorities;
    this.customBtnDialog.title = row.customTriggerButtonProperty.buttonName;
    this.customBtnDialog.fieldAuthoritiesMap = {};
    this.customBtnDialog.form = {};
    this.customBtnDialog.showFields = [];
    this.customBtnDialog.row = row;
    this.$nextTick(() => {
      this.customBtnDialog.customBtnVisible = true;
      this.customBtnDialog.form = cloneDeep(this.form);
      this.customBtnDialog.showFields = fieldAuthorities
        .map((item) => {
          return this.fieldsMap[item.fieldId] || null;
        })
        .filter((item) => item);
      fieldAuthorities.forEach((item) => {
        this.customBtnDialog.fieldAuthoritiesMap[item.fieldId] = item.authority;
      });
    });
  }
  private closeAssociationTable(isChange) {
    if (
      isChange &&
      this.isReadOnly &&
      this.showFieldList.find((item) => item.fieldType === 'statistics')
    ) {
      this.$router.replace(`${this.$route.path}?${Math.random()}`);
      return;
    }
  }
  private submit() {
    let form = this.$refs.form as any;
    let p1 = form.validate();
    p1.then(async () => {
      let data = {};
      // 现实的字段提交
      this.widgetArr.forEach((one) => {
        // 备注，分割线不添加
        if (notAddField.includes(one.item.fieldType)) {
          return;
        }
        if (one.item.fieldType === 'autoNumber') {
          return;
        }
        let businessId = one.item.businessId;
        data[businessId] = this.form[businessId];
      });
      // 隐藏的字段提交
      this.permissionHiddenList.forEach((item) => {
        // 备注，分割线不添加
        if (notAddField.includes(item.fieldType)) {
          return;
        }
        if (item.fieldType === 'autoNumber') {
          return;
        }
        let businessId = item.businessId;
        data[businessId] = this.form[businessId];
      });
      let res: any = {};
      if (this.drawer.type === 'add') {
        res = await this.addRecord(data);
        if (res.success) {
          this.$emit('search', this.drawer.type, res.data);
        }
      } else {
        res = await this.updateRecord(data);
        if (res.success) {
          this.isReadOnly = true;
          if (
            this.showFieldList.find(
              (item) => item.fieldType === 'childTable' || item.fieldType === 'associationTable'
            )
          ) {
            this.$router.replace(`${this.$route.path}?${Math.random()}`);
            return;
          }
          this.cacheData = cloneDeep(Object.assign({}, this.cacheData, data));
          this.addFormWatch();
        }
      }
    }).catch((e) => {
      console.log(e);
    });
  }
  private async addRecord(data) {
    // 双向关联添加记录
    if ((this as any).bidirectionalAssociation) {
      return sheetAPI.addRecordBidirectional({
        ...(this as any).bidirectionalAssociation,
        associationTableData: data,
      });
    }
    return sheetAPI.addRecord({ data, worksheetId: (this as any).worksheetId });
  }
  private async updateRecord(data) {
    return sheetAPI.updateRecord({ data, id: this.id, worksheetId: (this as any).worksheetId });
  }
  // 公式计算
  private autoDefault(item, resultFn?: (p: any, m?: any) => any) {
    if (item.defaultType === 2 && item.defaultValue) {
      let set = new Set<string>();
      item.defaultValue.replace(reg, (match, $1) => {
        set.add($1);
      });
      if (!set.size && isUndef(this.form[item.businessId])) {
        let formula = getFormula(item);
        this.form[item.businessId] = resultFn
          ? resultFn(formula.evaluate({}), item)
          : formula.evaluate({});
        return;
      }
      let SheetField = this.fieldsMap;
      let arr = [...set];
      arr.forEach((businessId) => {
        let unwatch = this.$watch(
          'form.' + businessId,
          val => {
            let params = {};
            let hasValue = Array.from(set).every(one => {
              if (!this.form[one]) {
                return false;
              }
              let field = SheetField[one] || {};
              params[one] = handleValueFormula(this.form[one], field);
              return true;
            });
            if (hasValue) {
              let formula = getFormula(item);
              // 返回值处理
              this.form[item.businessId] = resultFn
                ? resultFn(formula.evaluate(params), item)
                : formula.evaluate(params);
            }
          }
          // { immediate: this.form[item.businessId] === undefined }
        );
        this.unWatchList.push(unwatch);
      });
    }
  }
  private getDynamicValue(item) {
    let { dynamicValue = '' } = item.defaultValue || {};
    dynamicValue = dynamicValue ? dynamicValue.split(',') : [];
    dynamicValue.forEach((businessId) => {
      let unwatch = this.$watch(
        'form.' + businessId,
        (newV, oldV = '') => {
          if (isUndef(newV)) {
            return;
          }
          newV = newV.split(',').filter((id) => id);
          if (item.selectType === selectE.radio) {
            this.form[item.businessId] = newV[0] || '';
          } else {
            oldV = oldV.split(',').filter((id) => id);
            let remove: string[] = difference(oldV, newV);
            let value = this.form[item.businessId] || '';
            let valueArr = value.split(',').filter((id) => id);
            newV.forEach((id) => {
              if (!valueArr.includes(id)) {
                valueArr.push(id);
              }
            });
            remove.forEach((id) => {
              let index = valueArr.indexOf(id);
              if (index !== -1) {
                valueArr.splice(index, 1);
              }
            });
            this.form[item.businessId] = valueArr.join(',');
          }
        },
        { immediate: isUndef(this.form[item.businessId]) }
      );
      this.unWatchList.push(unwatch);
    });
  }
}
